function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import TextField from '../TextField';
const NumberField = _ref => {
  let {
    min,
    max,
    step,
    ...otherProps
  } = _ref;
  const inputProps = {
    ...otherProps.inputProps,
    type: "number",
    min,
    max,
    step
  };
  return /*#__PURE__*/React.createElement(TextField, _extends({}, otherProps, {
    inputProps: inputProps
  }));
};
export default NumberField;